import {get, post, patch, del} from './http';

export type EscalationVariant = {
  id: string;
  policy_violation: string;
  name: string;
  sort_order: number;
};

export type CreateEscalationVariantRequest = {
  policy_violation: string;
  name: string;
  sort_order?: number;
};

export type UpdateEscalationVariantRequest = {
  name?: string;
  sort_order?: number;
};

export type EscalationContactRule = {
  id: string;
  name: string;
  policy_violation: string | null;
  escalation_variant: string | null;
  days_of_week: string | null;
  start_time: string | null;
  end_time: string | null;
  time_zone: string;
  to_emails: string[];
  cc_emails: string[];
  bcc_emails: string[];
  slack_channel_ids: string[];
  enabled: boolean;
  created_by: string;
  created_at: string;
  modified_by: string | null;
  modified_at: string | null;
};

export type CreateEscalationContactRuleRequest = {
  name: string;
  policy_violation?: string | null;
  escalation_variant?: string | null;
  days_of_week?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  time_zone?: string;
  to_emails?: string[];
  cc_emails?: string[];
  bcc_emails?: string[];
  slack_channel_ids?: string[];
  enabled?: boolean;
};

export type UpdateEscalationContactRuleRequest = {
  name?: string;
  policy_violation?: string | null;
  clear_policy_violation?: boolean;
  escalation_variant?: string | null;
  clear_escalation_variant?: boolean;
  days_of_week?: string | null;
  clear_days_of_week?: boolean;
  start_time?: string | null;
  end_time?: string | null;
  clear_time_window?: boolean;
  time_zone?: string;
  to_emails?: string[];
  cc_emails?: string[];
  bcc_emails?: string[];
  slack_channel_ids?: string[];
  enabled?: boolean;
};

export type EscalationResolveResult = {
  to_emails: string[];
  cc_emails: string[];
  bcc_emails: string[];
  slack_channels: string[];
  matched_rules: Array<{id: string; name: string}>;
};

export const escalationApi = {
  listVariants: async (policyViolation?: string) =>
    get<EscalationVariant[]>(
      '/escalation-variants',
      policyViolation ? {policy_violation: policyViolation} : undefined
    ),

  createVariant: async (body: CreateEscalationVariantRequest) =>
    post<CreateEscalationVariantRequest, EscalationVariant>('/escalation-variants', body),

  updateVariant: async (id: string, body: UpdateEscalationVariantRequest) =>
    patch<UpdateEscalationVariantRequest, EscalationVariant>(`/escalation-variants/${id}`, body),

  deleteVariant: async (id: string) => del(`/escalation-variants/${id}`),

  listRules: async () => get<EscalationContactRule[]>('/escalation-contact-rules'),

  createRule: async (body: CreateEscalationContactRuleRequest) =>
    post<CreateEscalationContactRuleRequest, EscalationContactRule>(
      '/escalation-contact-rules',
      body
    ),

  updateRule: async (id: string, body: UpdateEscalationContactRuleRequest) =>
    patch<UpdateEscalationContactRuleRequest, EscalationContactRule>(
      `/escalation-contact-rules/${id}`,
      body
    ),

  deleteRule: async (id: string) => del(`/escalation-contact-rules/${id}`),

  resolve: async (policyViolation?: string, escalationVariants?: string[], at?: string) =>
    get<EscalationResolveResult>('/escalation-contact-rules/resolve', {
      policy_violation: policyViolation,
      escalation_variant: escalationVariants,
      at
    })
};
